import "./gen-sdk";
import throttle from "lodash.throttle";

declare global {
  interface Window {
    GD_OPTIONS: {
      gameId: string;
      prefix?: string;
      onEvent: (event: SDKGameEvent) => void;
    };
    gdsdk: {
      showAd: () => void;
    };
  }
}

interface SDKGameEvent {
  name: GDSDKEvent;
}

enum GDSDKEvent {
  Ready = "SDK_READY",
  Start = "SDK_GAME_START", // advertisement done, resume game logic and unmute audio
  Pause = "SDK_GAME_PAUSE", // pause game logic / mute audio
  AdError = "AD_ERROR",
  ContentPauseRequested = "CONTENT_PAUSE_REQUESTED",
  ContentResumeRequested = "CONTENT_RESUME_REQUESTED",
}

type CBFunc = () => void

class GameController {
  static sdkReadyCallback: CBFunc;
  constructor() {
    console.log("=============== It's working =============");
    console.log("================== Yass ==================");
  }

  static initialize() {
    const eventData = {
      payload: {},
      event: "getGameData",
      type: "response",
    };
    window.postMessage(eventData, "*");
  }

  static integrateAzerionSDKWithGameEvents() {
    window["GD_OPTIONS"] = {
      gameId: "9305b14607394af493700d600ee3be4c",
      // gameId: "[YOUR GD GAME ID HERE]",
      prefix: "gzp__",
      onEvent: function (event) {
        switch (event.name) {
          case GDSDKEvent.Start:
            playAndUnmute();
            break;
          case GDSDKEvent.Pause:
            pauseAndMute();
            break;
          case GDSDKEvent.AdError:
            playAndUnmute();
            break;
        }
      },
    };
  }

  static fetchGDSDK() {
    (function (d, s, id) {
      let js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://html5.api.gamedistribution.com/main.min.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "gamedistribution-jssdk");
  }

  static showAd() {
    // this check ensures that we throttle only if the GD SDK was loaded
    if (window?.gdsdk?.showAd) {
      showThrottledAds();
    }
  }
}

const twoMinutes = 2 * (1000 * 60);
const showThrottledAds = throttle(
  () => {
    window.gdsdk.showAd();
  },
  twoMinutes,
  { trailing: false }
);

function pauseAndMute() {
  window?.gamezop?.pause();
  mute();
}

function playAndUnmute() {
  window?.gamezop?.play();
  unmute();
}

function unmute() {
  window?.gamezop?.unmute();
}

function mute() {
  window?.gamezop?.mute();
}

export default GameController;
